<template>
  <b-modal
    ref="manageFirewallModal"
    centered
    size="lg"
    :title="firewallsModalTitle"
    hide-header-close
    body-class="pt-4"
    footer-bg-variant=""
    @hidden="unselectFirewall(), clearErrors()">
    <b-form @submit.stop.prevent>
      <b-form-group
        id="name-firewall"
        label="Name"
        label-for="name-input">
        <b-form-input
          id="name-input"
          name="name-input"
          v-model="selectedFirewall.name"
          :state="getValidationState('name')"
          aria-describedby="name-feedback"
          placeholder="HTTPS Restriction" />
        <b-form-invalid-feedback
          v-for="(error, index) in manageFirewallError('name')"
          :key="`${error.field}-${index}`">
          {{ error.message }}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group
        id="code-firewall"
        label="Code"
        label-for="code-input">
        <b-form-input
          id="code-input"
          name="code-input"
          v-model="selectedFirewall.slug"
          :disabled="selectedFirewallExist"
          :state="getValidationState('slug')"
          aria-describedby="code-feedback"
          placeholder="only_https" />
        <b-form-invalid-feedback
          v-for="(error, index) in manageFirewallError('code')"
          :key="`${error.field}-${index}`">
          {{ error.message }}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group
        id="source-code"
        label="Source Code"
        label-for="source-code"
        class="w-100 mb-0">
        <b-form-textarea
          id="source-textarea"
          name="source-textarea"
          v-model="selectedFirewall.source_raw"
          rows="10"
          resize
          :state="getValidationState('source_raw')"
          aria-describedby="source-feedback"
          :placeholder="firewallSourceCodePlaceholder" />
        <b-form-invalid-feedback
          v-for="(error, index) in manageFirewallError('source_raw')"
          :key="`${error.field}-${index}`">
          {{ error.message }}
        </b-form-invalid-feedback>
      </b-form-group>
    </b-form>

    <template #modal-footer>
      <div class="d-flex w-100 pt-2">
        <b-button
          variant="outline-secondary"
          size="md"
          @click="hideModal('manageFirewallModal')">
          Cancel
        </b-button>
        <b-button
          type="submit"
          v-wave
          variant="primary"
          size="md"
          class="ml-auto"
          :disabled="firewallsResponses('manageFirewallModal')"
          @click="submitFirewall()">
          Submit
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {
  // actions
  GET_FIREWALLS,
  MANAGE_FIREWALL,

  // mutations
  UNSELECT_FIREWALL,
  CLEAR_MANAGE_FIREWALL_ERRORS
} from '@/core/services/store/firewalls.module'
import { showModal, hideModal, onHideAttempt } from '@/core/utils'
import { mapGetters } from 'vuex'
import { eventBus } from '@/main'

export default {
  name: 'ModalManageFirewall',
  data() {
    return {
      showModal,
      hideModal,
      onHideAttempt,
    }
  },
  computed: {
    ...mapGetters([
      'selectedFirewall',
      'selectedFirewallId',
      'selectedFirewallExist',
      'firewallsModalTitle',
      'firewallsResponses',
      'firewallSourceCodePlaceholder',
      'manageFirewallErrors',
      'manageFirewallError',
    ]),
  },
  mounted() {
    eventBus.$on('openModal', type => { this.showModal(type) })
  },
  destroyed() {
    eventBus.$off('openModal')
  },
  methods: {
    submitFirewall() {
      this.$store.dispatch(MANAGE_FIREWALL)
        .then(() => {
          this.hideModal('manageFirewallModal')
        })
        .finally(() => {
          this.getFirewalls()
        })
    },

    getFirewalls() {
      this.$store.dispatch(GET_FIREWALLS)
    },

    unselectFirewall() {
      this.$store.commit(UNSELECT_FIREWALL)
    },

    clearErrors() {
      this.$store.commit(CLEAR_MANAGE_FIREWALL_ERRORS)
    },

    getValidationState(field) {
      return this.manageFirewallErrors.some(err => err.field == field) ? false : null
    },
  }
}
</script>
